// extracted by mini-css-extract-plugin
export default {"title":"section-heading-module--title--NRpWU","subtitle":"section-heading-module--subtitle--F6euS"};